
export default [
     // ================ 1、首页 =================
    {
        path: 'home',
        name: 'home',
        meta: {
          title: '首页',
        },
        component: () => import('@/views/home')
    },
    // ================ 2、产品中心 =================
    // 2.1产品中心-列表 
    {
        path: 'productList',
        name: 'productList',
        meta: {
            title: '产品中心',
        },
        component: () => import('@/views/productCenter/productList')
    },
     //  2.2 产品中心-硬件产品
    {
      path: 'productHardware',
      name: 'productHardware',
      meta: {
        title: '硬件产品',
      },
      component: () => import('@/views/productCenter/productHardware')
    },
     //  2.3 产品中心-焊接云平台
    {
      path: 'weldCloud',
      name: 'weldCloud',
      meta: {
        title: '软件产品--焊接云平台',
      },
      component: () => import('@/views/productCenter/weldCloud')
    },
    //  2.4 产品中心-软件产品(压力容器，钢结构，智慧焊培，焊工信息，智能焊缝，智能视讯，智能机器人，管道焊接，焊接工艺，焊材库，奥太微群控小程序，奥太资料库)
     {
      path: 'productSoftware',
      name: 'productSoftware',
      meta: {
        title: '软件产品',
      },
      component: () => import('@/views/productCenter/productSoftware')
    },
    //  2.5 产品中心-软件产品--app(掌上群控，焊接，运维)
    {
      path: 'productSoftwareApp',
      name: 'productSoftwareApp',
      meta: {
        title: '软件产品--app(掌上群控，焊接，运维)',
      },
      component: () => import('@/views/productCenter/productSoftwareApp')
    },
  
   
      // ================ 3、关于我们 =================
    // =================== 3、解决方案 =================
    //   3.1解决方案-列表
    {
        path: 'solutionList',
        name: 'solutionList',
        meta: {
        title: '解决方案',
        },
        component: () => import('@/views/solution/list')
    },
    //   3.2解决方案-详情
    {
        path: 'solutionDetail',
        name: 'solutionDetail',
        meta: {
            title: '解决方案详情',
        },
        component: () => import('@/views/solution/deatil')
    },
     // =================== 4、应用案例 =================
     {
        path: 'caseList',
        name: 'caseList',
        meta: {
          title: '应用案例',
        },
        component: () => import('@/views/applyCase/list')
      },

    // =================== 5、新闻资讯 =================
    // 5.1新闻资讯--列表
    {
        path: 'news',
        name: 'news',
        meta: {
        title: '新闻资讯',
        },
        component: () => import('@/views/newsInfo/news')
    },
    // 5.2新闻资讯--详情
    {
        path: 'newsDetail',
        name: 'newsDetail',
        meta: {
        title: '新闻资讯详情',
        },
        component: () => import('@/views/newsInfo/newsDetail')
    },
    // =================== 6、资料中心 =================
    // 6.1资料中心-资料下载
    {
        path: 'resourceList',
        name: 'resourceList',
        meta: {
        title: '资源下载-列表',
        },
        component: () => import('@/views/resourceCentre/resourceList')
    },
    // 6.2资料中心-行业标准
    {
      path: 'industry',
      name: 'industry',
      meta: {
        title: '行业标准',
      },
      component: () => import('@/views/resourceCentre/industry')
    },
    // 6.3资料中心-焊工小知识
    {
      path: 'weldCertificate',
      name: 'weldCertificate',
      meta: {
        title: '焊工小知识',
      },
      component: () => import('@/views/resourceCentre/weldCertificate')
    },

     
       // =================== 7、视频资料 =================
      {
        path: 'videoList',
        name: 'videoList',
        meta: {
          title: '视频资料',
        },
        component: () => import('@/views/resourceCentre/videoList')
      },
      // =================== 8、关于我们 =================
      {
        path: 'about',
        name: 'about',
        meta: {
          title: '我的',
        },
        component: () => import('@/views/about/index')
      },
    // =================== 9、系统配置 =================
       {
            path: "system",
            name: "system",
            target:true,
            meta: {
            title: '系统展示',
            hiddenNode: true,
            trrget: "_blank",
            },
            component: () => import('@/views/system') 
        },
    // =================== 10、系统体验 =================
      {
        path: "login",
        name: "login",
        meta: {
          title: '登陆',
          hiddenNode: true,
          trrget: "_blank",
        },
        component: () => import('@/views/login') 
      }
  
  ]

